/*
 * Public API Surface of uimm-tooltip
 */

export * from './lib/tooltip/tooltip.component';
export * from './lib/uimm-tooltip.module';
export * from './lib/tooltip.directive';
